import React, { useState, useEffect } from 'react';
import FileUpload from './components/FileUpload';
import DataVisualization from './components/DataVisualization';
import ResultsTable from './components/ResultsTable';
import Login from './components/Login';
import WorkflowButtons from './components/WorkflowButtons';
import './App.css';

function App() {
  const [predictionResults, setPredictionResults] = useState(null);
  const [historicalData, setHistoricalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedVariety, setSelectedVariety] = useState('');
  const [selectedProductionArea, setSelectedProductionArea] = useState('all');
  const [selectedSeason, setSelectedSeason] = useState('all');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Check authentication status on app load
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('token');
      if (token) {
        setIsAuthenticated(true);
      }
      setIsCheckingAuth(false);
    };

    checkAuthStatus();
  }, []);

  const handlePredictionComplete = (results, historical) => {
    setPredictionResults(results);
    setHistoricalData(historical);
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setLoading(false);
  };

  const handleRowSelect = (variety, productionArea) => {
    setSelectedVariety(variety);
    setSelectedProductionArea(productionArea);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setPredictionResults(null);
    setHistoricalData(null);
  };

  if (isCheckingAuth) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Tomato Yield Predictor</h1>
        </header>
        <main className="App-main">
          <div>Checking authentication...</div>
        </main>
      </div>
    );
  }

  // Render the login component if the user is not authenticated
  if (!isAuthenticated) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Tomato Yield Predictor</h1>
        </header>
        <main className="App-main">
          <Login onLoginSuccess={handleLoginSuccess} />
        </main>
      </div>
    );
  }

  // Render the main application if the user is authenticated
  return (
    <div className="App">
      <header className="App-header">
        <h1>Tomato Yield Predictor</h1>
        {isAuthenticated && (
          <button onClick={handleLogout} style={{ marginLeft: 'auto' }}>
            Logout
          </button>
        )}
      </header>

      <main className="App-main">
        {error && (
          <div className="error-message">
            <p>Error: {error}</p>
            <button onClick={() => setError(null)}>Dismiss</button>
          </div>
        )}

        <WorkflowButtons onError={handleError} />
        <FileUpload
          onPredictionComplete={handlePredictionComplete}
          onError={handleError}
          loading={loading}
          setLoading={setLoading}
        />

        {predictionResults && (
          <>
            <ResultsTable
              data={predictionResults}
              historicalData={historicalData}
              onError={handleError}
              onSelect={handleRowSelect}
            />

            {historicalData && (
              <DataVisualization
                predictionData={predictionResults}
                historicalData={historicalData}
                selectedVariety={selectedVariety}
                selectedProductionArea={selectedProductionArea}
                selectedSeason={selectedSeason}
                setSelectedVariety={setSelectedVariety}
                setSelectedProductionArea={setSelectedProductionArea}
                setSelectedSeason={setSelectedSeason}
              />
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default App;